import { Component, OnInit } from '@angular/core';
import { AboutApiService } from 'carehub-api/about-api.service';
import { SettingsApiService } from 'carehub-api/settings-api.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SettingsEntry } from 'carehub-api/models/settingsentry';
import * as fromShared from 'carehub-shared/state';
import * as sharedActions from 'carehub-shared/state/shared.actions';
import { User } from 'carehub-shared/state/shared.reducer';
import * as fromRoot from 'carehub-root/state/app.state';
import { Store, select } from '@ngrx/store';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['../test.component.scss'],
})
export class AboutComponent implements OnInit {
  settings$: Observable<SettingsEntry[]>;
  about$: Observable<any>;
  user$: Observable<User>;
  environmentSettings: any;

  constructor(
    private sharedStore: Store<fromRoot.State>,
    private aboutService: AboutApiService,
    private settingsService: SettingsApiService
  ) {}

  ngOnInit() {
    this.settings$ = this.settingsService.getSettings();
    this.about$ = this.aboutService.getAboutDetails();
    this.environmentSettings = environment;
    this.user$ = this.sharedStore.pipe(select(fromShared.getCurrentUser));
  }
}
